import { render, staticRenderFns } from "./ManyBarChart.vue?vue&type=template&id=527f44c0"
import script from "./ManyBarChart.vue?vue&type=script&lang=js"
export * from "./ManyBarChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports